


















import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

@Component({})
export default class CardItem extends Vue {
  @Prop({ default: false }) readonly loading!: boolean;
  @Prop() readonly icon!: string;
  @Prop({ default: "grey" }) readonly iconColor!: string;
  @Prop() readonly title!: string;
  @Prop() readonly content!: string;
}
